import { css } from "@emotion/react";

type StatusBarProps = {
  plataformId: number;
};

const StatusBar = ({ plataformId }: StatusBarProps) => {
  return (
    <div
      css={css`
        align-items: center;
        display: flex;
        color: #6c757d;
        font-size: 12px;
        margin-bottom: 10px;
        justify-content: center;
      `}
    >
      © {""}
      {plataformId === 1 || plataformId === 2
        ? "imbot"
        : plataformId === 3 || plataformId === 4
        ? "spaik"
        : ""}
    </div>
  );
};

export default StatusBar;
